import sortBy from 'lodash/sortBy';
import map from 'lodash/map';
import filter from 'lodash/filter';
import memoizee from 'memoizee';

/**
 * Returns a list of recommended controls given case conf data
 *
 * The reason the subfields of the case are provided
 * as separate arguments is so that they can be indivudally
 * memoized. We could memoize the whole caseConf but that would
 * mean everytime we make changes to any part of the case, the
 * case ref has to be updated and that triggers a rerender of
 * almost every component. A wrapper function is exported so
 * this detail is hidden
 */
const getRecommendedControlsMemoized = memoizee(
  (
    dosageForms,
    fluids,
    _oxygens,
    _treatments,
    _labAssets,
    _startLocation,
    _endLocation,
    caseLogicDescription,
    dialogue,
    customMenus,
    availableInterventions,
    spinalAssessments,
    iv,
    npcs,
    controls,
    isGlobal,
  ) =>
    filter(
      sortBy(
        map(controls, (control, key) => ({
          ...control,
          key,
          recommended:
            !isGlobal && control.isRecommended
              ? control.isRecommended({
                  dosageForms,
                  fluids,
                  _oxygens,
                  _treatments,
                  _labAssets,
                  _startLocation,
                  _endLocation,
                  caseLogicDescription,
                  dialogue,
                  customMenus,
                  availableInterventions,
                  spinalAssessments,
                  iv,
                  npcs,
                })
              : true,
        })),
        (c) => (c.recommended ? 0 : 1)
      ),
      (control) => (isGlobal ? !control.caseSpecific : true)
    )
);
const getRecommendedControls = (caseConf, controls, isGlobal) => {
  const {
    dosageForms,
    fluids,
    _oxygens,
    _treatments,
    _labAssets,
    _startLocation,
    _endLocation,
    caseLogicDescription,
    dialogue,
    customMenus,
    availableInterventions,
    spinalAssessments,
    iv,
    npcs,
  } = caseConf || {};
  return getRecommendedControlsMemoized(
    dosageForms,
    fluids,
    _oxygens,
    _treatments,
    _labAssets,
    _startLocation,
    _endLocation,
    caseLogicDescription,
    dialogue,
    customMenus,
    availableInterventions,
    spinalAssessments,
    iv,
    npcs,
    controls,
    isGlobal,
  );
};

export default getRecommendedControls;
